import React, { Component } from 'react';
import Tabs from '../Tabs/Tabs';

if (process.browser) require('./TabbedContent.scss');

export default class TabbedContent extends Component {
  state = {
    selectedIndex: 0
  };

  render() {
    const { tabs = [], onChange } = this.props;
    if (!tabs.length) return null;

    const { selectedIndex } = this.state;
    const { panel, id } = tabs[selectedIndex];
    const onChangeHandler = (index) => {
      this.setState({
        selectedIndex: index,
      });
      return onChange && onChange(index);
    };

    return (
      <div className="tabs tabbedcontent">
        <Tabs tabs={tabs} onChange={onChangeHandler} selectedIndex={selectedIndex} />
        <div className="content-tabs">
          <div
            id={`panel-${id}`}
            role="tabpanel"
            aria-labelledby={`tab-${id}`}
          >
            { panel }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/TabbedContent/TabbedContent.js